import { createColumnHelper } from '@tanstack/react-table';
import { HeadCell } from 'components/tables/cells';
import { MontelAccount } from 'domain/account/interfaces';
import { UnassignSeatActionCell } from './UnassignSeatActionCell';
import { Subscription } from 'domain/subscription/interfaces/Subscription';

const columnHelper = createColumnHelper<MontelAccount>();

export const subscriptionUsersTableColumns = {
	unassignSeatAction: (
		subscription: Subscription,
		onSuccess: (subscriberId: string) => void,
	) =>
		columnHelper.accessor(() => null, {
			id: 'actions',
			enableSorting: false,
			meta: { width: '120px' },
			header: () => <HeadCell text="" />,
			cell: (info) => (
				<UnassignSeatActionCell
					subscriberId={info.row.original.id}
					subscription={subscription}
					onSuccess={onSuccess}
				/>
			),
		}),
};
